import { UIState } from './types/reducerTypes'
import { AnyAction } from 'redux'

const defaultState: UIState = {
  side_panel_opened: true,
  side_panel_visible: false,
  focusableComponents: {},
  focusedComponent: '',
}

export default function reducer(state = defaultState, action: AnyAction) {
  switch (action.type) {
    case 'REGISTER_SCREEN':
      return { ...state }

    case 'REGISTER_FOCUSABLE_COMPONENT':
      return {
        ...state,
        focusableComponents: {
          screen: action.payload,
        },
      }

    case 'SET_SIDE_PANEL_VISIBILITY':
      return { ...state, side_panel_visible: action.visible }

    case 'OPEN_SIDE_PANEL':
      return {
        ...state,
        focusedComponent: 'SidePanel',
        side_panel_opened: true,
      }

    case 'CLOSE_SIDE_PANEL':
      return {
        ...state,
        focusedComponent: action.componentToFocus,
        side_panel_opened: false,
      }

    case 'SET_FOCUS_COMPONENT':
      return { ...state, focusedComponent: action.componentToFocus }
    default:
      return state
  }
}
